const TermsAnchor = {
  TermsOfUse: '#terms-of-use',
  TermsOfSale: '#terms-of-sale',
};

export { TermsAnchor };
